__turbopack_context__.v({
  "card": "GridLibrary-module__ktsWHW__card",
  "cardHeader": "GridLibrary-module__ktsWHW__cardHeader",
  "description": "GridLibrary-module__ktsWHW__description",
  "exchangeChip": "GridLibrary-module__ktsWHW__exchangeChip",
  "exchangeList": "GridLibrary-module__ktsWHW__exchangeList",
  "footer": "GridLibrary-module__ktsWHW__footer",
  "grid": "GridLibrary-module__ktsWHW__grid",
  "intro": "GridLibrary-module__ktsWHW__intro",
  "kindChip": "GridLibrary-module__ktsWHW__kindChip",
  "meta": "GridLibrary-module__ktsWHW__meta",
  "metaLabel": "GridLibrary-module__ktsWHW__metaLabel",
  "metaRow": "GridLibrary-module__ktsWHW__metaRow",
  "metaValue": "GridLibrary-module__ktsWHW__metaValue",
  "name": "GridLibrary-module__ktsWHW__name",
  "notes": "GridLibrary-module__ktsWHW__notes",
  "planLink": "GridLibrary-module__ktsWHW__planLink",
  "planNote": "GridLibrary-module__ktsWHW__planNote",
  "root": "GridLibrary-module__ktsWHW__root",
});
